module.exports = __webpack_public_path__ + "static/media/sardine-2.91a03773.jpg";